// Global Variables/Objects
const patternData = window.patternData;

if (typeof patternData !== "undefined") {
  window.currentBundle = {
    projects: {},
    accessories: {},
    totalPriceCents: 0,
  };

  addEventListeners();

  // Run main logic on initial load and back navigation
  // window.addEventListener("DOMContentLoaded", main); // Run script on initial load
  window.addEventListener("pageshow", main); // Run script when users hits back button

  function main() {
    initializeCurrentBundle();

    document
      .querySelectorAll(".project-selector input")
      .forEach((projectCheckbox) => {
        projectCheckbox.dispatchEvent(new Event("change"));
      });

    for (const projectId of patternData.projectOrder) {
      updateCurrentBundleFromSize(projectId);
      updateCurrentBundleFromColors(projectId);
      updateCurrentBundleFromAccessories();
      updateYarnQuantitiesInDom(projectId);
    }
    calculateTotalPrice();
  }

  // Begin helper function definitions
  function addEventListeners() {
    const patternOnlyCheckBox = document.getElementById(
      "pattern-only-checkbox"
    );
    patternOnlyCheckBox.addEventListener("change", (event) => {
      if (patternOnlyCheckBox.checked) {
        const productFormButton = document.querySelector(
          ".product-form__buttons button"
        );

        for (const projectId of patternData.projectOrder) {
          removeProjectFromCurrentBundle(projectId);
          uncheckProjectCheckboxInDOM(projectId);
          collapseProjectInDOM(projectId);
        }
        for (const accessoryKey in patternData.accessories) {
          delete currentBundle.accessories[accessoryKey];
        }
        const accessoriesCheckbox = document.querySelectorAll(
          ".accessories-selector input"
        );
        Array.from(accessoriesCheckbox).forEach((checkBox) => {
          checkBox.checked = false;
        });
        calculateTotalPrice();
        productFormButton.disabled = false;
      }
    });

    const projectSelectors = document.querySelectorAll(
      ".project-selector input"
    );
    Array.from(projectSelectors).forEach((selector) => {
      selector.addEventListener("change", (event) => {
        // const projectElement = selector.closest(".project");
        const projectId = selector.closest(".project").id;

        const productFormButton = document.querySelector(
          ".product-form__buttons button"
        );

        if (!selector.checked) {
          removeProjectFromCurrentBundle(projectId);
          collapseProjectInDOM(projectId);
          calculateTotalPrice();
          updateAddToCartButton = (() => {
            for (const projectId of patternData.projectOrder) {
              if (!allYarnOptionsSelected(projectId)) {
                productFormButton.disabled = true;
                return;
              }
            }
            productFormButton.disabled = false;
          })();
        } else {
          const patternOnlyCheckBox = document.getElementById(
            "pattern-only-checkbox"
          );
          patternOnlyCheckBox.checked = false;
          expandProjectInDOM(projectId);
          // Initialize this project in currentBundle
          currentBundle.projects[projectId] = { size: null, colors: {} };
          const projectData = patternData.projects[projectId];
          for (let i = 1; i <= projectData.numberOfColors; i++) {
            const colorKey = `color${i}`;
            currentBundle.projects[projectId].colors[colorKey] = {
              yarnTitle: "",
              quantity: 0,
              variantId: null,
              price: null,
            };
          }
          updateCurrentBundleFromSize(projectId);
          updateCurrentBundleFromColors(projectId);
          calculateTotalPrice();
          if (!allYarnOptionsSelected(projectId))
            productFormButton.disabled = true;
        }
      });
    });

    // Event listener for open close button in the project selector
    const projectButtons = document.querySelectorAll(".open-close-button");
    Array.from(projectButtons).forEach((button) => {
      button.addEventListener("click", (event) => {
        const projectId = button.closest(".project").id;
        const projectCheckBox = document.querySelector(
          `#${projectId} .project-selector input`
        );

        // Toggle the checkbox state
        projectCheckBox.checked = !projectCheckBox.checked;

        // Dispatch the change event to trigger the existing listener
        projectCheckBox.dispatchEvent(new Event("change"));
      });
    });

    const accordionHeaders = document.querySelectorAll(".accordion-header");
    Array.from(accordionHeaders).forEach((header) => {
      if (header.classList.contains("project-name")) {
        return;
      }
      header.addEventListener("click", (event) => {
        const accordionBody =
          header.parentElement.querySelector(".accordion-body");
        accordionBody.classList.toggle("accordion-collapsed");
      });
    });

    const sizeButtons = document.querySelectorAll(".size-buttons label");
    Array.from(sizeButtons).forEach((button) => {
      button.addEventListener("click", (event) => {
        const projectId = button.closest(".project").id;
        const projectElement = button.closest(".project");
        updateCurrentBundleFromSize(projectId);
        calculateTotalPrice();
        updateYarnQuantitiesInDom(projectId);

        accordionHeaderSelectedSizeIcon = projectElement.querySelector(
          ".accordion-header-selected-size-icon"
        );

        accordionHeaderSelectedSizeIcon.innerText =
          button.querySelector("span").innerText;
      });
    });

    const colorSelectorButtons = document.querySelectorAll(
      ".color-selector-btn"
    );
    Array.from(colorSelectorButtons).forEach((button) => {
      button.addEventListener("click", (event) => {
        const projectElement = button.closest(".project");
        // Remove "selected" class from all buttons in the project-color-display container
        Array.from(
          projectElement.querySelectorAll(".color-selector-btn")
        ).forEach((button) => {
          button.classList.remove("selected");
        });

        // Add "selected" class to the clicked button
        event.currentTarget.classList.add("selected");
      });
    });

    const clearAllButtons = document.querySelectorAll(".clear-all-yarns-btn");
    Array.from(clearAllButtons).forEach((clearButton) => {
      clearButton.addEventListener("click", (event) => {
        const projectId = clearButton.closest(".project").id;
        const projectElement = document.querySelector(`#${projectId}`);
        const colorSelectorButtons = Array.from(
          projectElement.querySelectorAll(".color-selector-btn")
        );
        const productFormButton = document.querySelector(
          ".product-form__buttons button"
        );
        const accordionHeaderSelectedYarnIconsContainer =
          projectElement.querySelector(".accordion-header-selected-yarn-icons");
        const chooseHereText =
          projectElement.querySelector(".choose-here-text");

        colorSelectorButtons.forEach((colorSelectorButton, index) => {
          // Remove "selected" class from all buttons in the project-color-display container
          colorSelectorButton.classList.remove("selected");
          // Add "selected" class to first button
          if (index === 0) {
            colorSelectorButton.classList.add("selected");
          }
          // Reset value empty string
          colorSelectorButton.value = "";
          // Dom manipulation
          const innerCircleElement =
            colorSelectorButton.querySelector("svg .inner-circle");
          innerCircleElement.classList.remove("hidden");
          innerCircleElement.style.stroke = "#FF9191";

          const colorSelectorImgElement =
            colorSelectorButton.querySelector("svg image");
          colorSelectorImgElement.removeAttribute("href");

          const svgPathElement = colorSelectorButton.querySelector("svg path");
          svgPathElement.classList.remove("hidden");

          const yarnColorName = colorSelectorButton
            .closest("li")
            .querySelector(".yarn-color-name");
          yarnColorName.innerText = "Add colour";
        });

        accordionHeaderSelectedYarnIconsContainer.classList.add("hidden");
        chooseHereText.classList.remove("hidden");

        updateCurrentBundleFromColors(projectId);
        calculateTotalPrice();
        productFormButton.disabled = true;
      });
    });

    const colorSwatchButtons = document.querySelectorAll(".yarn-choice-btn");
    Array.from(colorSwatchButtons).forEach((button) => {
      button.addEventListener("click", (event) => {
        const projectId = button.closest(".project").id;
        const projectElement = document.querySelector(`#${projectId}`);
        const colorSelectorButtons = Array.from(
          projectElement.querySelectorAll(".color-selector-btn")
        );
        const productFormButton = document.querySelector(
          ".product-form__buttons button"
        );

        // Find the currently selected button and its index
        const selectedIndex = colorSelectorButtons.findIndex((selector) =>
          selector.classList.contains("selected")
        );

        if (selectedIndex !== -1) {
          // Update the value of the currently selected button
          const selectedColorSelectorButton =
            colorSelectorButtons[selectedIndex];
          selectedColorSelectorButton.value = button.value;

          // Dom manipulation
          const innerCircleElement =
            selectedColorSelectorButton.querySelector("svg .inner-circle");
          const selectedColorSelectorImgElement =
            selectedColorSelectorButton.querySelector("svg image");
          const colorSwatchButtonImgElement = button.querySelector("svg image");
          selectedColorSelectorImgElement.setAttribute(
            "href",
            colorSwatchButtonImgElement.getAttribute("href")
          );
          innerCircleElement.style.stroke = "none";

          const svgPathElement =
            selectedColorSelectorButton.querySelector("svg path");
          svgPathElement.classList.add("hidden");

          const yarnColorName = selectedColorSelectorButton
            .closest("li")
            .querySelector(".yarn-color-name");
          yarnColorName.innerText = button
            .closest("li")
            .querySelector(".yarn-choice-name").innerText;

          const accordionHeaderSelectedYarnIconsContainer =
            projectElement.querySelector(
              ".accordion-header-selected-yarn-icons"
            );

          const chooseHereText =
            projectElement.querySelector(".choose-here-text");

          correspondingSelectedYarnIcon = projectElement.querySelector(
            `svg[data-color-key=${selectedColorSelectorButton.id}]`
          );

          correspondingSelectedYarnIconImage =
            correspondingSelectedYarnIcon.querySelector("image");

          correspondingSelectedYarnIconImage.setAttribute(
            "href",
            colorSwatchButtonImgElement.getAttribute("href")
          );

          updateCurrentBundleFromColors(projectId);

          if (allYarnOptionsSelected(projectId)) {
            accordionHeaderSelectedYarnIconsContainer.classList.remove(
              "hidden"
            );
            chooseHereText.classList.add("hidden");
            calculateTotalPrice();
          }

          updateAddToCartButton = (() => {
            for (const projectId of patternData.projectOrder) {
              if (!allYarnOptionsSelected(projectId)) {
                productFormButton.disabled = true;
                return;
              }
            }
            productFormButton.disabled = false;
          })();

          // Remove "selected" class from the current button
          selectedColorSelectorButton.classList.remove("selected");

          // Calculate the next index using modular arithmetic for circular rotation
          const nextIndex = (selectedIndex + 1) % colorSelectorButtons.length;

          // Add "selected" class to the next button in the loop
          const nextColorSelectorButton = colorSelectorButtons[nextIndex];
          nextColorSelectorButton.classList.add("selected");
        }
      });
    });

    const accessoriesHeader = document.querySelector(".accessories-header");
    accessoriesHeader.addEventListener("click", (event) => {
      const accessoriesBody = document.querySelector(".accessories-body");
      const accessoriesSelector = document.querySelector(
        ".accessories-selector"
      );
      accessoriesBody.classList.contains("accordion-collapsed")
        ? (accessoriesSelector.style.backgroundColor = "")
        : (accessoriesSelector.style.backgroundColor = "#ebebeb");
    });

    const accessoriesCheckbox = document.querySelectorAll(
      ".accessories-selector input"
    );
    Array.from(accessoriesCheckbox).forEach((checkBox) => {
      checkBox.addEventListener("change", (event) => {
        const patternOnlyCheckBox = document.getElementById(
          "pattern-only-checkbox"
        );
        patternOnlyCheckBox.checked = false;
        updateCurrentBundleFromAccessories();
        calculateTotalPrice();
      });
    });
  }

  function initializeCurrentBundle() {
    for (const projectId of patternData.projectOrder) {
      currentBundle.projects[projectId] = { size: null, colors: {} };

      const projectData = patternData.projects[projectId];
      for (let i = 1; i <= projectData.numberOfColors; i++) {
        const colorKey = `color${i}`;
        currentBundle.projects[projectId].colors[colorKey] = {
          yarnTitle: "",
          quantity: 0,
          variantId: null,
          price: null,
        };
      }
    }
  }

  function updateCurrentBundleFromSize(projectId) {
    if (currentBundle.projects[projectId]) {
      const projectElement = document.querySelector(`#${projectId}`);
      const selectedSizeButton = projectElement.querySelector(
        ".size-buttons input:checked"
      );
      const selectedSizeButtonValue = selectedSizeButton.value;
      const yarnQuantity =
        patternData.projects[projectId].sizes[selectedSizeButtonValue];
      const yarnQuantityArray = Object.values(yarnQuantity);

      // Update quantity for each color in the current bundle
      yarnQuantityArray.forEach((yarnQuantity, index) => {
        currentBundle.projects[projectId].colors[`color${index + 1}`].quantity =
          yarnQuantity;
      });

      // Update the size in the current bundle
      currentBundle.projects[projectId].size = selectedSizeButtonValue;
    }
  }

  function updateCurrentBundleFromColors(projectId) {
    if (currentBundle.projects[projectId]) {
      const projectElement = document.querySelector(`#${projectId}`);
      const colorSelectorButtons = projectElement.querySelectorAll(
        ".color-selectors button"
      );
      Array.from(colorSelectorButtons).forEach((selector) => {
        const selectorId = selector.id;
        const variantName = selector.value;

        if (variantName) {
          // Update the yarnTitle in the current bundle
          const yarnTitle = selector
            .closest("li")
            .querySelector(".yarn-color-name").innerText;
          currentBundle.projects[projectId].colors[selectorId].yarnTitle =
            yarnTitle;

          // Update the variantId in the current bundle
          const variantId = patternData.yarnVariants[variantName].variantId;
          currentBundle.projects[projectId].colors[selectorId].variantId =
            variantId;

          // Update the price in the current bundle
          const price = patternData.yarnVariants[variantName].price;
          currentBundle.projects[projectId].colors[selectorId].price = price;
        } else {
          // reset currentBundle yarnTitle
          currentBundle.projects[projectId].colors[selectorId].yarnTitle = "";
          // reset currentBundle variantId
          currentBundle.projects[projectId].colors[selectorId].variantId = null;
          // reset currentBundle price
          currentBundle.projects[projectId].colors[selectorId].price = null;
        }
      });
    }
  }

  function updateCurrentBundleFromAccessories() {
    const accessoriesCheckbox = document.querySelectorAll(
      ".accessories-selector input"
    );
    Array.from(accessoriesCheckbox).forEach((checkBox) => {
      if (!checkBox.checked) {
        delete currentBundle.accessories[checkBox.value];
      } else {
        currentBundle.accessories[checkBox.value] = {
          accessoryTitle: "",
          variantId: null,
          price: null,
        };
        const accessoryElement = checkBox.closest(".accessory");
        const accessoryTitle =
          accessoryElement.querySelector("label").innerText;
        currentBundle.accessories[checkBox.value].accessoryTitle =
          accessoryTitle;

        const variantId = patternData.accessories[checkBox.value].variantId;
        currentBundle.accessories[checkBox.value].variantId = variantId;

        const price = patternData.accessories[checkBox.value].price;
        currentBundle.accessories[checkBox.value].price = price;
      }
    });
  }

  function updateYarnQuantitiesInDom(projectId) {
    const projectElement = document.querySelector(`#${projectId}`);
    const yarnQuantityDisplays = projectElement.querySelectorAll(
      ".yarn-quantity-display"
    );
    const selectedSizeButton = projectElement.querySelector(
      ".size-buttons input:checked"
    );
    const selectedSizeButtonValue = selectedSizeButton.value;
    const yarnQuantity =
      patternData.projects[projectId].sizes[selectedSizeButtonValue];
    const yarnQuantityArray = Object.values(yarnQuantity);

    yarnQuantityArray.forEach((quantity, index) => {
      if (yarnQuantityDisplays[index]) {
        yarnQuantityDisplays[index].innerText = `(${quantity} yarn)`;
      }
    });
  }

  function removeProjectFromCurrentBundle(projectId) {
    delete currentBundle.projects[projectId];
  }

  function collapseProjectInDOM(projectId) {
    const projectElement = document.querySelector(`#${projectId}`);
    const projectAccordionBody = document.querySelector(
      `#${projectId} .accordion-body`
    );
    const projectHeaderButton = document.querySelector(
      `#${projectId} .open-close-button`
    );
    projectAccordionBody.classList.add("accordion-collapsed");
    projectHeaderButton.innerText = "EDIT";
    projectElement.style.backgroundColor = "";
  }

  function expandProjectInDOM(projectId) {
    const projectElement = document.querySelector(`#${projectId}`);
    const projectAccordionBody = document.querySelector(
      `#${projectId} .accordion-body`
    );
    const projectHeaderButton = document.querySelector(
      `#${projectId} .open-close-button`
    );
    projectAccordionBody.classList.remove("accordion-collapsed");
    projectHeaderButton.innerText = "CLOSE";
    projectElement.style.backgroundColor = "#ebebeb";
  }

  function uncheckProjectCheckboxInDOM(projectId) {
    const projectCheckBox = document.querySelector(
      `#${projectId} .project-selector input`
    );
    projectCheckBox.checked = false;
  }

  function allYarnOptionsSelected(projectId) {
    const projectSelected = document.querySelector(
      `#${projectId} .project-selector input`
    ).checked;

    if (!projectSelected) {
      return true;
    }

    if (currentBundle.projects[projectId]) {
      const projectData = patternData.projects[projectId];
      for (let i = 1; i <= projectData.numberOfColors; i++) {
        const colorKey = `color${i}`;
        if (currentBundle.projects[projectId].colors[colorKey].price === null)
          return false;
      }
      return true;
    }
  }

  function calculateTotalPrice() {
    let price = 0;

    for (let projectKey in currentBundle.projects) {
      let project = currentBundle.projects[projectKey];

      for (let colorKey in project.colors) {
        let color = project.colors[colorKey];
        price += color.price * color.quantity;
      }
    }

    for (let accessoryKey in currentBundle.accessories) {
      let accessory = currentBundle.accessories[accessoryKey];
      price += accessory.price;
    }

    price += patternData.patternPrice;

    currentBundle.totalPriceCents = price;
    updateTotalPrice();
  }

  function updateTotalPrice(params) {
    const totalPriceCents = currentBundle.totalPriceCents;
    const totalPriceDollars = (totalPriceCents / 100).toFixed(2);
    priceElementRegular = document.querySelector(
      ".price-item.price-item--regular"
    );
    priceElementRegular.innerText = `£${totalPriceDollars} GBP`;
  }
}
